export { default } from './RatesModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/RatesModal/index.js